import React, { useState, useEffect } from 'react';
import PageLayout from '../../Components/PageLayout';
import { useTiles } from '../../hooks/useTiles';
import "../../Css/Home.css";
import Tileboard from "../../Components/Tileboard/Tileboard";

function Dashboard() {
  const { data: tiles = [], isLoading, error } = useTiles();
  const [tileState, setTileState] = useState(tiles);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    setTileState(tiles);
  }, [tiles]);

  const recentPrintsData = [
    { id: 1, thumb: "Thumb A", title: "Print A", printer: "Bazylia" },
    { id: 2, thumb: "Thumb B", title: "Print B", printer: "Bolek" },
    { id: 3, thumb: "Thumb C", title: "Print C", printer: "Lolek" },
    { id: 4, thumb: "Thumb D", title: "Print D", printer: "Test" },
  ];

  const statisticsData = [
    { id: 1, metric: "Success Rate", value: "98%" },
    { id: 2, metric: "Printing time", value: "1:04" },
  ];

  if (isLoading) {
    return <PageLayout title="Dashboard" subtitle="Quick Preview"><div>Loading tiles...</div></PageLayout>;
  }

  if (error) {
    return <PageLayout title="Dashboard" subtitle="Quick Preview"><div style={{ color: "red" }}>Error loading tiles: {error.message}</div></PageLayout>;
  }

  return (
    <PageLayout title="Dashboard" subtitle="Quick Preview">
      <label>
        <input
          type="checkbox"
          checked={editMode}
          style={{ marginBottom: "1rem" }}
          onChange={e => setEditMode(e.target.checked)}
        />
        Tryb edycji kafelków
      </label>
      <div className="tileboard-area">
        <Tileboard tiles={tileState} setTiles={setTileState} editMode={editMode} />
      </div>
      
      <div className="flex box-container">
        <section className="recent_prints box">
          <div className="recent_prints">
            <h1>Recent Prints</h1>
            <table className="recent-prints-table">
              <thead>
                <tr className='table-header'>
                  <th className='small-text table-thumb'>Thumb</th>
                  <th className='table-title'>Title</th>
                  <th className='table-printer'>Printer</th>
                </tr>
              </thead>
              <tbody>
                {recentPrintsData.map((print) => (
                  <tr key={print.id}>
                    <td>{print.thumb}</td>
                    <td>{print.title}</td>
                    <td>{print.printer}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="statistics box">
          <div>
            <h1>Statistics</h1>
            <table className="statistics-table">
              <thead>
                <tr className='table-header'>
                  <th className='table-success'></th>
                  <th className='table-time'></th>
                </tr>
              </thead>
              <tbody>
                {statisticsData.map((stat) => (
                  <tr key={stat.id}>
                    <td>{stat.metric}<hr /></td>
                    <td>{stat.value}<hr /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
      </PageLayout>
  );
}

export default Dashboard;
